import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../breakpoints'
import { CareRadioButton } from './CareRadioButton'

export type CareSelectionProps = {
  options: { label: string; value: string; hint: string }[]
  onChange: (id: string) => void
  value: string
}

export const CareSelection = ({
  options,
  onChange,
  value,
}: CareSelectionProps) => {
  if (!options.length) {
    return <></>
  }

  return (
    <Container>
      <H2>Sélectionnez votre soin</H2>
      <div>
        {options.map(option => (
          <CareRadioButton
            key={option.value}
            option={option}
            checked={option.value === value}
            onChange={() => onChange(option.value)}
          />
        ))}
      </div>
    </Container>
  )
}

const Container = styled.div`
  background-color: #f2f2f2;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const H2 = styled.h2`
  margin: 0 auto 20px auto;
  font-size: 2rem;
  font-weight: 500;
  text-align: center;
  max-width: 270px;

  ${mq.lg} {
    max-width: inherit;
  }
`
